import { render, staticRenderFns } from "./ClipboardTypeIcon.vue?vue&type=template&id=5b6acf34&scoped=true"
import script from "./ClipboardTypeIcon.vue?vue&type=script&lang=js"
export * from "./ClipboardTypeIcon.vue?vue&type=script&lang=js"
import style0 from "./ClipboardTypeIcon.vue?vue&type=style&index=0&id=5b6acf34&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6acf34",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b6acf34')) {
      api.createRecord('5b6acf34', component.options)
    } else {
      api.reload('5b6acf34', component.options)
    }
    module.hot.accept("./ClipboardTypeIcon.vue?vue&type=template&id=5b6acf34&scoped=true", function () {
      api.rerender('5b6acf34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/common/clipboard/ClipboardTypeIcon.vue"
export default component.exports